// extracted by mini-css-extract-plugin
export default {"invoice":"Invoice_invoice__Anz+B","invoiceHeader":"Invoice_invoiceHeader__gHywD","invoiceItem":"Invoice_invoiceItem__TJ8ix","downloadButton":"Invoice_downloadButton__Pnwwm"};